import * as button from './apps/app/components/Button.stories.tsx'
import * as card from './apps/app/components/Card.stories.tsx'
import * as logo from './apps/app/components/Logo.stories.tsx'
import * as radio from './apps/app/components/Radio.stories.tsx'
import * as title from './apps/app/components/Title.stories.tsx'
import * as topbar from './apps/app/components/TopBar.stories.tsx'
import * as voting from './apps/app/components/Voting.stories.tsx'
const storiesRaw = {button,card,logo,radio,title,topbar,voting};
const storiesParsed = {
  "button": {
    "id": "button",
    "fileName": "Button",
    "filePath": "apps/app/components/Button.stories.tsx",
    "fileContent": {
      "meta": {
        "name": "Button",
        "group": "Components",
        "section": "components",
        "icon": "edit",
        "component": null,
        "subtitle": "Primary button component with hover and disabled states.",
        "showApi": true,
        "importSource": "@functions/app",
        "id": "button"
      },
      "blocks": [
        {
          "name": "Default",
          "description": "Standard button with default styling.",
          "style": {
            "size": "small"
          },
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender meta={meta} blocks={blocks} block={block}>\n          <Button>Click me</Button>\n        </ComponentRender>\n      )\n    }",
          "id": "default"
        },
        {
          "name": "Disabled",
          "description": "Button in disabled state.",
          "style": {
            "size": "small"
          },
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender meta={meta} blocks={blocks} block={block}>\n          <Button disabled>Disabled</Button>\n        </ComponentRender>\n      )\n    }",
          "id": "disabled"
        },
        {
          "name": "Custom Styles",
          "description": "Button with custom inline styles.",
          "style": {
            "size": "small"
          },
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender meta={meta} blocks={blocks} block={block}>\n          <Button\n            style={{\n              backgroundColor: '#28a745',\n              padding: '1rem 2rem',\n              fontSize: '1.2rem',\n            }}\n          >\n            Custom Button\n          </Button>\n        </ComponentRender>\n      )\n    }",
          "id": "customstyles"
        },
        {
          "name": "With onClick",
          "description": "Button with click handler.",
          "style": {
            "size": "small"
          },
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender meta={meta} blocks={blocks} block={block}>\n          <Button onClick={() => alert('Button clicked!')}>Click me!</Button>\n        </ComponentRender>\n      )\n    }",
          "id": "withonclick"
        }
      ]
    }
  },
  "card": {
    "id": "card",
    "fileName": "Card",
    "filePath": "apps/app/components/Card.stories.tsx",
    "fileContent": {
      "meta": {
        "name": "Card",
        "group": "Components",
        "section": "components",
        "icon": "edit",
        "component": {
          "importSource": "./Card",
          "exportType": "named",
          "description": null,
          "displayName": "Card",
          "propsTypeName": "CardProps",
          "props": {
            "name": {
              "name": "name",
              "type": "string",
              "required": true,
              "description": null,
              "defaultValue": null
            },
            "song": {
              "name": "song",
              "type": "string",
              "required": true,
              "description": null,
              "defaultValue": null
            },
            "nationality": {
              "name": "nationality",
              "type": "string",
              "required": true,
              "description": null,
              "defaultValue": null
            },
            "lyrics": {
              "name": "lyrics",
              "type": "string",
              "required": true,
              "description": null,
              "defaultValue": null
            }
          }
        },
        "subtitle": "Eurovision contestant card displaying artist information and lyrics.",
        "showApi": true,
        "importSource": "@functions/app",
        "id": "card"
      },
      "blocks": [
        {
          "name": "Default",
          "description": "Standard card with typical contestant information.",
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender meta={meta} blocks={blocks} block={block}>\n          <Card\n            name=\"John Doe\"\n            song=\"Amazing Song\"\n            nationality=\"Sweden\"\n            lyrics=\"These are the lyrics to an amazing song that will win Eurovision. The melody is catchy and the performance is stunning.\"\n          />\n        </ComponentRender>\n      )\n    }",
          "id": "default"
        },
        {
          "name": "Long Lyrics",
          "description": "Card with extensive lyrics showing truncation.",
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender meta={meta} blocks={blocks} block={block}>\n          <Card\n            name=\"Maria Garcia\"\n            song=\"Dreams Come True\"\n            nationality=\"Spain\"\n            lyrics=\"Verse 1: In the morning light, I see the world anew, Every dream I had is coming into view. The stars aligned, the moment is here, With every heartbeat, I conquer my fear. Chorus: Dreams come true when you believe, In the magic that you can achieve. Rise above, reach for the sky, On wings of hope, we learn to fly. Verse 2: Through the darkest nights, I kept the faith alive, Now I stand here strong, ready to thrive.\"\n          />\n        </ComponentRender>\n      )\n    }",
          "id": "longlyrics"
        },
        {
          "name": "Minimal Info",
          "description": "Card with minimal contestant information.",
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender meta={meta} blocks={blocks} block={block}>\n          <Card\n            name=\"Alex\"\n            song=\"Untitled\"\n            nationality=\"TBD\"\n            lyrics=\"Lyrics not available.\"\n          />\n        </ComponentRender>\n      )\n    }",
          "id": "minimalinfo"
        },
        {
          "name": "Special Characters",
          "description": "Card with special characters and emojis.",
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender meta={meta} blocks={blocks} block={block}>\n          <Card\n            name=\"Björk Guðmundsdóttir\"\n            song=\"❤️ Love & Peace ☮️\"\n            nationality=\"Iceland 🇮🇸\"\n            lyrics=\"♪ ♫ Music speaks where words fail ♬ ♭\"\n          />\n        </ComponentRender>\n      )\n    }",
          "id": "specialcharacters"
        }
      ]
    }
  },
  "logo": {
    "id": "logo",
    "fileName": "Logo",
    "filePath": "apps/app/components/Logo.stories.tsx",
    "fileContent": {
      "meta": {
        "name": "Logo",
        "group": "Components",
        "section": "components",
        "icon": "edit",
        "component": {
          "importSource": "./Logo",
          "exportType": "named",
          "description": null,
          "displayName": "Logo",
          "propsTypeName": null,
          "props": {}
        },
        "subtitle": "Based.io logo component.",
        "showApi": true,
        "importSource": "@functions/app",
        "id": "logo"
      },
      "blocks": [
        {
          "name": "Default",
          "description": "Standard logo display.",
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender meta={meta} blocks={blocks} block={block}>\n          <Logo />\n        </ComponentRender>\n      )\n    }",
          "id": "default"
        },
        {
          "name": "Dark Background",
          "description": "Logo on dark background.",
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender\n          meta={meta}\n          blocks={blocks}\n          block={block}\n          style={{ backgroundColor: '#131313' }}\n        >\n          <Logo />\n        </ComponentRender>\n      )\n    }",
          "id": "darkbackground"
        },
        {
          "name": "Light Background",
          "description": "Logo on light background.",
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender\n          meta={meta}\n          blocks={blocks}\n          block={block}\n          style={{ backgroundColor: '#f5f5f5' }}\n        >\n          <Logo />\n        </ComponentRender>\n      )\n    }",
          "id": "lightbackground"
        }
      ]
    }
  },
  "radio": {
    "id": "radio",
    "fileName": "Radio",
    "filePath": "apps/app/components/Radio.stories.tsx",
    "fileContent": {
      "meta": {
        "name": "Radio",
        "group": "Components",
        "section": "components",
        "icon": "edit",
        "component": null,
        "subtitle": "Radio button components for single selection.",
        "showApi": true,
        "importSource": "@functions/app",
        "id": "radio"
      },
      "blocks": [
        {
          "name": "Single Option",
          "description": "Radio group with single option.",
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender meta={meta} blocks={blocks} block={block}>\n          <RadioGroup>\n            <RadioLabel>\n              <RadioInput type=\"radio\" name=\"option\" value=\"single\" />\n              Single Option\n            </RadioLabel>\n          </RadioGroup>\n        </ComponentRender>\n      )\n    }",
          "id": "singleoption"
        },
        {
          "name": "Multiple Options",
          "description": "Radio group with multiple options.",
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender meta={meta} blocks={blocks} block={block}>\n          <RadioGroup>\n            <RadioLabel>\n              <RadioInput\n                type=\"radio\"\n                name=\"choice\"\n                value=\"option1\"\n                defaultChecked\n              />\n              Option 1\n            </RadioLabel>\n            <RadioLabel>\n              <RadioInput type=\"radio\" name=\"choice\" value=\"option2\" />\n              Option 2\n            </RadioLabel>\n            <RadioLabel>\n              <RadioInput type=\"radio\" name=\"choice\" value=\"option3\" />\n              Option 3\n            </RadioLabel>\n          </RadioGroup>\n        </ComponentRender>\n      )\n    }",
          "id": "multipleoptions"
        },
        {
          "name": "Disabled Options",
          "description": "Radio group with disabled options.",
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender meta={meta} blocks={blocks} block={block}>\n          <RadioGroup>\n            <RadioLabel>\n              <RadioInput type=\"radio\" name=\"disabled\" value=\"enabled\" />\n              Enabled Option\n            </RadioLabel>\n            <RadioLabel style={{ opacity: 0.5, cursor: 'not-allowed' }}>\n              <RadioInput\n                type=\"radio\"\n                name=\"disabled\"\n                value=\"disabled\"\n                disabled\n              />\n              Disabled Option\n            </RadioLabel>\n          </RadioGroup>\n        </ComponentRender>\n      )\n    }",
          "id": "disabledoptions"
        },
        {
          "name": "Custom Styling",
          "description": "Radio group with custom styles.",
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender meta={meta} blocks={blocks} block={block}>\n          <RadioGroup style={{ gap: '2rem' }}>\n            <RadioLabel style={{ padding: '1rem', backgroundColor: '#e3f2fd' }}>\n              <RadioInput type=\"radio\" name=\"styled\" value=\"blue\" />\n              Blue Theme\n            </RadioLabel>\n            <RadioLabel style={{ padding: '1rem', backgroundColor: '#f3e5f5' }}>\n              <RadioInput type=\"radio\" name=\"styled\" value=\"purple\" />\n              Purple Theme\n            </RadioLabel>\n          </RadioGroup>\n        </ComponentRender>\n      )\n    }",
          "id": "customstyling"
        }
      ]
    }
  },
  "title": {
    "id": "title",
    "fileName": "Title",
    "filePath": "apps/app/components/Title.stories.tsx",
    "fileContent": {
      "meta": {
        "name": "Title",
        "group": "Components",
        "section": "components",
        "icon": "edit",
        "component": {
          "importSource": "./Title",
          "exportType": "named",
          "description": null,
          "displayName": "Title",
          "propsTypeName": "TitleProps",
          "props": {
            "variant": {
              "name": "variant",
              "type": "'h1' | 'h2'",
              "required": false,
              "description": null,
              "defaultValue": null
            },
            "align": {
              "name": "align",
              "type": "'left' | 'center' | 'right'",
              "required": false,
              "description": null,
              "defaultValue": null
            },
            "color": {
              "name": "color",
              "type": "string",
              "required": false,
              "description": null,
              "defaultValue": null
            },
            "style": {
              "name": "style",
              "type": "Style",
              "required": false,
              "description": null,
              "defaultValue": null
            },
            "children": {
              "name": "children",
              "type": "React.ReactNode",
              "required": false,
              "description": null,
              "defaultValue": null
            }
          }
        },
        "subtitle": "Flexible title component with variant and alignment options.",
        "showApi": true,
        "importSource": "@functions/app",
        "id": "title"
      },
      "blocks": [
        {
          "name": "H2 Default",
          "description": "Default h2 title.",
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender meta={meta} blocks={blocks} block={block}>\n          <Title>Default Heading</Title>\n        </ComponentRender>\n      )\n    }",
          "id": "h2default"
        },
        {
          "name": "H1 Variant",
          "description": "Large h1 title.",
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender meta={meta} blocks={blocks} block={block}>\n          <Title variant=\"h1\">Primary Heading</Title>\n        </ComponentRender>\n      )\n    }",
          "id": "h1variant"
        },
        {
          "name": "Left Aligned",
          "description": "Title aligned to the left.",
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender meta={meta} blocks={blocks} block={block}>\n          <Title align=\"left\">Left Aligned Title</Title>\n        </ComponentRender>\n      )\n    }",
          "id": "leftaligned"
        },
        {
          "name": "Center Aligned",
          "description": "Title aligned to the center.",
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender meta={meta} blocks={blocks} block={block}>\n          <Title align=\"center\">Center Aligned Title</Title>\n        </ComponentRender>\n      )\n    }",
          "id": "centeraligned"
        },
        {
          "name": "Right Aligned",
          "description": "Title aligned to the right.",
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender meta={meta} blocks={blocks} block={block}>\n          <Title align=\"right\">Right Aligned Title</Title>\n        </ComponentRender>\n      )\n    }",
          "id": "rightaligned"
        },
        {
          "name": "Custom Color",
          "description": "Title with custom color.",
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender meta={meta} blocks={blocks} block={block}>\n          <Title color=\"#3498db\">Colored Title</Title>\n        </ComponentRender>\n      )\n    }",
          "id": "customcolor"
        },
        {
          "name": "Custom Styles",
          "description": "Title with custom inline styles.",
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender meta={meta} blocks={blocks} block={block}>\n          <Title\n            style={{\n              textTransform: 'uppercase',\n              letterSpacing: '2px',\n              borderBottom: '2px solid #333',\n              paddingBottom: '0.5rem',\n            }}\n          >\n            Styled Title\n          </Title>\n        </ComponentRender>\n      )\n    }",
          "id": "customstyles"
        },
        {
          "name": "All Options",
          "description": "Title with all customization options.",
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender meta={meta} blocks={blocks} block={block}>\n          <Title\n            variant=\"h1\"\n            align=\"center\"\n            color=\"#e74c3c\"\n            style={{\n              textShadow: '2px 2px 4px rgba(0,0,0,0.1)',\n            }}\n          >\n            My song contest\n          </Title>\n        </ComponentRender>\n      )\n    }",
          "id": "alloptions"
        }
      ]
    }
  },
  "topbar": {
    "id": "topbar",
    "fileName": "TopBar",
    "filePath": "apps/app/components/TopBar.stories.tsx",
    "fileContent": {
      "meta": {
        "name": "TopBar",
        "group": "Components",
        "section": "components",
        "icon": "edit",
        "component": {
          "importSource": "./TopBar",
          "exportType": "named",
          "description": null,
          "displayName": "TopBar",
          "propsTypeName": null,
          "props": {}
        },
        "subtitle": "Navigation bar with logo and action buttons.",
        "showApi": true,
        "importSource": "@functions/app",
        "id": "topbar"
      },
      "blocks": [
        {
          "name": "Default",
          "description": "Standard topbar with navigation buttons.",
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender meta={meta} blocks={blocks} block={block}>\n          <TopBar />\n        </ComponentRender>\n      )\n    }",
          "id": "default"
        },
        {
          "name": "Mobile View",
          "description": "Topbar responsive behavior on mobile.",
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender\n          meta={meta}\n          blocks={blocks}\n          block={block}\n          style={{ maxWidth: '480px' }}\n        >\n          <TopBar />\n        </ComponentRender>\n      )\n    }",
          "id": "mobileview"
        },
        {
          "name": "Full Width",
          "description": "Topbar spanning full container width.",
          "code": "({ meta, blocks, block }) => {\n      return (\n        <ComponentRender\n          meta={meta}\n          blocks={blocks}\n          block={block}\n          style={{ width: '100%' }}\n        >\n          <TopBar />\n        </ComponentRender>\n      )\n    }",
          "id": "fullwidth"
        }
      ]
    }
  },
  "voting": {
    "id": "voting",
    "fileName": "Voting",
    "filePath": "apps/app/components/Voting.stories.tsx",
    "fileContent": {
      "meta": {
        "name": "Voting",
        "group": "Components",
        "section": "components",
        "icon": "edit",
        "component": null,
        "subtitle": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        "showApi": true,
        "importSource": "@based/ui",
        "id": "voting"
      },
      "blocks": [
        {
          "name": "Default",
          "description": "Et harum quidem rerum facilis est et expedita distinctio.",
          "props": {},
          "style": {
            "size": "100%",
            "frame": {
              "inner": false
            },
            "flex": {
              "justifyContent": "center",
              "alignItems": "center"
            }
          },
          "id": "default"
        }
      ]
    }
  }
};
export const sections = {
  "components": 7
};

function mergeObjects(rawContent, parsedContent) {
  const result = { ...parsedContent }

  const allKeys = new Set([
    ...Object.keys(rawContent),
    ...Object.keys(parsedContent),
  ])

  for (const key of allKeys) {
    const rawValue = rawContent[key]
    const parsedValue = parsedContent[key]

    if (parsedValue === undefined) {
      result[key] = rawValue

      continue
    }

    if (parsedValue === null) {
      result[key] = rawValue !== undefined ? rawValue : null

      continue
    }

    if (
      typeof parsedValue === 'object' &&
      parsedValue !== null &&
      !Array.isArray(parsedValue)
    ) {
      if (
        typeof rawValue === 'object' &&
        rawValue !== null &&
        !Array.isArray(rawValue)
      ) {
        result[key] = mergeObjects(rawValue, parsedValue)
      } else {
        result[key] = mergeObjects({}, parsedValue)
      }

      continue
    }

    if (Array.isArray(parsedValue)) {
      if (Array.isArray(rawValue)) {
        result[key] = parsedValue.map((item, index) => {
          const rawItem = rawValue[index]

          if (item === null) {
            return rawItem !== undefined ? rawItem : null
          }

          if (
            typeof item === 'object' &&
            item !== null &&
            !Array.isArray(item)
          ) {
            if (
              typeof rawItem === 'object' &&
              rawItem !== null &&
              !Array.isArray(rawItem)
            ) {
              return mergeObjects(rawItem, item)
            }

            return mergeObjects({}, item)
          }

          if (Array.isArray(item)) {
            if (Array.isArray(rawItem)) {
              return item.map((subItem, subIndex) => {
                const rawSubItem = rawItem[subIndex]

                if (subItem === null) {
                  return rawSubItem !== undefined ? rawSubItem : null
                }

                if (
                  typeof subItem === 'object' &&
                  subItem !== null &&
                  !Array.isArray(subItem)
                ) {
                  return mergeObjects(rawSubItem || {}, subItem)
                }

                return subItem
              })
            }

            return item
          }

          return item
        })
      } else {
        result[key] = parsedValue
      }

      continue
    }

    result[key] = parsedValue
  }

  return result
}

function mergeStories(storiesRaw, storiesParsed) {
  const finalResult = { ...storiesParsed }

  for (const rootKey of Object.keys(finalResult)) {
    const rootValue = finalResult[rootKey]

    if (
      rootValue &&
      typeof rootValue === 'object' &&
      !Array.isArray(rootValue) &&
      rootValue.fileContent
    ) {
      const rawContentForKey = storiesRaw[rootKey] || {}
      const parsedFileContent = rootValue.fileContent
      const fileContentMerged = mergeObjects(rawContentForKey, parsedFileContent)
      const componentElement = rawContentForKey.meta.component
      
      finalResult[rootKey] = {
        ...rootValue,
        fileContent: {
          ...fileContentMerged,
          meta: {
            ...fileContentMerged.meta,
            component: {
              ...fileContentMerged.meta.component,
              element: componentElement
            }
          }
        },
      }
    }
  }

  return finalResult
}
  
export const stories = mergeStories(storiesRaw, storiesParsed);